import { atom } from 'jotai';
import { unwrap } from 'jotai/utils';
import { unwrappedFilterSetsAtom } from '@/atoms/queries/userConfigs';
import { TEMPORARY_FILTER_SET_ID } from '@/consts/filters/filterSets';
import { Nullable } from '@/types/generic';
import { getTempFilterSet } from '@/utils/filters';
import { haveCompetitionOptionsLoadedAtom } from './highLevel/competitions';
import { haveSeasonOptionsLoadedAtom } from './highLevel/seasons';

export const selectedFilterSetIdAtom = atom<Nullable<string>>(null);

const selectedFilterSetAtom = atom(async get => {
  /* we want this to not return anything until the options have loaded */
  const haveCompetitionsLoaded = get(haveCompetitionOptionsLoadedAtom);
  const haveSeasonsLoaded = get(haveSeasonOptionsLoadedAtom);
  if (!haveCompetitionsLoaded || !haveSeasonsLoaded) return null;

  const filterSets = get(unwrappedFilterSetsAtom);
  const selectedFilterSetId = get(selectedFilterSetIdAtom);

  if (!filterSets || !selectedFilterSetId) return null;

  if (selectedFilterSetId === TEMPORARY_FILTER_SET_ID) {
    const tempFilterSet = await getTempFilterSet();
    return tempFilterSet;
  }

  return filterSets.find(config => config.configId === selectedFilterSetId) || null;
});

export const unwrappedSelectedFilterSetAtom = unwrap(selectedFilterSetAtom, prev => prev || null);
export const isLoadFilterSetModalOpenAtom = atom(false);
export const autoApplyFiltersAtom = atom(false);
